import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "home",
  class: "hero-section"
};
const _hoisted_2 = {
  class: "hero-container"
};
const _hoisted_3 = {
  class: "hero-copy"
};
const _hoisted_4 = {
  class: "hero-actions"
};
export default {
  __name: 'HomeSection',
  setup(__props) {
    const scrollToNext = () => {
      const nextSection = document.querySelector('#scenarios');
      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "hero-glow hero-glow-left",
        "aria-hidden": "true"
      }, null, -1)), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "hero-glow hero-glow-right",
        "aria-hidden": "true"
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("h1", {
        class: "hero-title"
      }, [_createTextVNode(" 让睡眠，"), _createElementVNode("br"), _createElementVNode("span", null, "被更精准地感知")], -1)), _cache[3] || (_cache[3] = _createElementVNode("p", {
        class: "hero-description"
      }, " 以脑电信号感知为入口，连接睡眠状态识别与智能音频干预， 构建从“感知”到“理解”再到“反馈”的智能睡眠闭环。 ", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        class: "hero-btn hero-btn-primary",
        to: "/product"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" 了解产品 "), _createElementVNode("span", {
          class: "btn-arrow",
          "aria-hidden": "true"
        }, "↗", -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        class: "hero-btn hero-btn-text",
        to: "/tech"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 探索核心技术 "), _createElementVNode("span", {
          class: "btn-arrow",
          "aria-hidden": "true"
        }, "→", -1)])),
        _: 1
      })]), _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"hero-meta\" aria-label=\"核心能力\" data-v-1cc21068><div class=\"meta-item\" data-v-1cc21068><span class=\"meta-index\" data-v-1cc21068>01</span><div data-v-1cc21068><strong data-v-1cc21068>脑电感知</strong><small data-v-1cc21068>EEG sensing</small></div></div><div class=\"meta-item\" data-v-1cc21068><span class=\"meta-index\" data-v-1cc21068>02</span><div data-v-1cc21068><strong data-v-1cc21068>状态识别</strong><small data-v-1cc21068>Sleep analysis</small></div></div><div class=\"meta-item\" data-v-1cc21068><span class=\"meta-index\" data-v-1cc21068>03</span><div data-v-1cc21068><strong data-v-1cc21068>智能干预</strong><small data-v-1cc21068>Adaptive audio</small></div></div></div>", 1))]), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "hero-visual",
        "aria-label": "智能睡眠系统示意"
      }, [_createElementVNode("div", {
        class: "visual-frame"
      }, [_createElementVNode("div", {
        class: "visual-label visual-label-top"
      }, [_createElementVNode("span", {
        class: "status-dot"
      }), _createTextVNode(" SLEEP SIGNAL ONLINE ")]), _createElementVNode("div", {
        class: "signal-panel"
      }, [_createElementVNode("div", {
        class: "panel-heading"
      }, [_createElementVNode("span", null, "EEG SIGNAL"), _createElementVNode("span", {
        class: "panel-time"
      }, "REAL TIME")]), _createElementVNode("svg", {
        class: "signal-wave",
        viewBox: "0 0 640 180",
        preserveAspectRatio: "none",
        role: "img",
        "aria-label": "脑电信号波形示意"
      }, [_createElementVNode("defs", null, [_createElementVNode("linearGradient", {
        id: "waveGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "0"
      }, [_createElementVNode("stop", {
        offset: "0%",
        "stop-color": "#6f8fff",
        "stop-opacity": "0.22"
      }), _createElementVNode("stop", {
        offset: "36%",
        "stop-color": "#4c74ff",
        "stop-opacity": "0.95"
      }), _createElementVNode("stop", {
        offset: "72%",
        "stop-color": "#43b9c8",
        "stop-opacity": "0.95"
      }), _createElementVNode("stop", {
        offset: "100%",
        "stop-color": "#79d9d0",
        "stop-opacity": "0.22"
      })]), _createElementVNode("filter", {
        id: "waveSoftGlow",
        x: "-20%",
        y: "-40%",
        width: "140%",
        height: "180%"
      }, [_createElementVNode("feGaussianBlur", {
        stdDeviation: "3",
        result: "blur"
      }), _createElementVNode("feMerge", null, [_createElementVNode("feMergeNode", {
        in: "blur"
      }), _createElementVNode("feMergeNode", {
        in: "SourceGraphic"
      })])])]), _createElementVNode("path", {
        class: "wave-path wave-shadow",
        d: "M0 92 C20 92 24 92 36 90 C49 88 58 98 71 95 C84 92 92 88 103 91 C118 95 124 111 135 108 C146 105 151 62 160 60 C171 58 176 128 188 130 C200 132 208 91 218 89 C228 87 238 96 250 94 C262 92 273 90 283 93 C298 98 302 111 315 107 C328 103 332 45 344 44 C356 43 361 138 374 140 C386 142 395 88 406 86 C417 84 427 95 440 93 C452 91 460 87 471 90 C483 93 489 105 500 103 C512 101 519 73 529 72 C541 70 547 116 558 117 C570 118 579 91 592 89 C605 87 618 92 640 92",
        fill: "none",
        stroke: "url(#waveGradient)",
        "stroke-width": "8",
        "stroke-linecap": "round",
        opacity: "0.13"
      }), _createElementVNode("path", {
        class: "wave-path",
        d: "M0 92 C20 92 24 92 36 90 C49 88 58 98 71 95 C84 92 92 88 103 91 C118 95 124 111 135 108 C146 105 151 62 160 60 C171 58 176 128 188 130 C200 132 208 91 218 89 C228 87 238 96 250 94 C262 92 273 90 283 93 C298 98 302 111 315 107 C328 103 332 45 344 44 C356 43 361 138 374 140 C386 142 395 88 406 86 C417 84 427 95 440 93 C452 91 460 87 471 90 C483 93 489 105 500 103 C512 101 519 73 529 72 C541 70 547 116 558 117 C570 118 579 91 592 89 C605 87 618 92 640 92",
        fill: "none",
        stroke: "url(#waveGradient)",
        "stroke-width": "2.6",
        "stroke-linecap": "round",
        filter: "url(#waveSoftGlow)"
      })]), _createElementVNode("div", {
        class: "signal-grid",
        "aria-hidden": "true"
      })]), _createElementVNode("div", {
        class: "system-stack"
      }, [_createElementVNode("div", {
        class: "wearable-visual",
        "aria-hidden": "true"
      }, [_createElementVNode("div", {
        class: "wearable-ring"
      }), _createElementVNode("div", {
        class: "wearable-core"
      }, [_createElementVNode("span", null, "EEG"), _createElementVNode("small", null, "SENSOR")]), _createElementVNode("span", {
        class: "sensor-node sensor-node-a"
      }), _createElementVNode("span", {
        class: "sensor-node sensor-node-b"
      }), _createElementVNode("span", {
        class: "sensor-node sensor-node-c"
      })]), _createElementVNode("div", {
        class: "flow-connector",
        "aria-hidden": "true"
      }, [_createElementVNode("span"), _createElementVNode("i")]), _createElementVNode("div", {
        class: "app-preview"
      }, [_createElementVNode("div", {
        class: "phone-topbar"
      }, [_createElementVNode("span", {
        class: "phone-pill"
      }), _createElementVNode("span", {
        class: "phone-state"
      }, "Sleep Tight")]), _createElementVNode("div", {
        class: "score-block"
      }, [_createElementVNode("span", {
        class: "score-label"
      }, "SLEEP STATUS"), _createElementVNode("strong", null, "Deep"), _createElementVNode("small", null, "实时睡眠状态识别")]), _createElementVNode("div", {
        class: "stage-chart",
        "aria-hidden": "true"
      }, [_createElementVNode("span", {
        class: "stage-line line-one"
      }), _createElementVNode("span", {
        class: "stage-line line-two"
      }), _createElementVNode("span", {
        class: "stage-line line-three"
      }), _createElementVNode("span", {
        class: "stage-line line-four"
      }), _createElementVNode("span", {
        class: "stage-line line-five"
      })]), _createElementVNode("div", {
        class: "audio-state"
      }, [_createElementVNode("span", {
        class: "audio-icon"
      }, [_createElementVNode("i"), _createElementVNode("i"), _createElementVNode("i"), _createElementVNode("i")]), _createElementVNode("div", null, [_createElementVNode("strong", null, "Adaptive Audio"), _createElementVNode("small", null, "动态调节中")])])])]), _createElementVNode("div", {
        class: "visual-caption"
      }, [_createElementVNode("span", null, "Sense"), _createElementVNode("i"), _createElementVNode("span", null, "Analyze"), _createElementVNode("i"), _createElementVNode("span", null, "Respond")])])], -1))]), _createElementVNode("button", {
        class: "scroll-indicator",
        type: "button",
        onClick: scrollToNext,
        "aria-label": "向下浏览"
      }, _cache[6] || (_cache[6] = [_createElementVNode("span", null, "SCROLL", -1), _createElementVNode("i", null, null, -1)]))]);
    };
  }
};